import { useSearchParams } from "react-router-dom";
import { GridApi } from "ag-grid-community";
import { useEffectOnceWhen } from "rooks";
import { useAppSelector } from "../../../../../store/hooks";
import {
  opportunityIdSearchParam,
  opportunityTypeTitlesByActionType,
} from "../constants/common";
import { savingsOpportunityByOpportunityIdSelector } from "../../../../../store/savings-opportunities/selectors/savingsOpportunityByOpportunityIdSelector";

export const useSavingsOpportunityIdFromUrl = (gridApi: GridApi | null) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const opportunityId = searchParams.get(opportunityIdSearchParam);

  const data = useAppSelector((state) =>
    savingsOpportunityByOpportunityIdSelector(state, opportunityId ?? ""),
  );

  useEffectOnceWhen(() => {
    if (!data) {
      return;
    }

    gridApi?.setFilterModel({
      action_type: {
        filterType: "multi",
        filterModels: [
          null,
          {
            values: [opportunityTypeTitlesByActionType[data.action_type]],
            filterType: "set",
          },
        ],
      },
      resource_id: {
        filterType: "multi",
        filterModels: [null, { values: [data.resource_id], filterType: "set" }],
      },
      resource_arn: {
        filterType: "resource_arn",
        filterModels: [
          null,
          { values: [data.resource_arn], filterType: "set" },
        ],
      },
    });

    searchParams.delete(opportunityIdSearchParam);
    setSearchParams(searchParams);
  }, !!gridApi && !!data);
};
